export default "__VITE_ASSET__BxdLyXKs__"